import { render, staticRenderFns } from "./RegistrarAsistenciaModal.vue?vue&type=template&id=8171a406&scoped=true"
import script from "./RegistrarAsistenciaModal.vue?vue&type=script&lang=js"
export * from "./RegistrarAsistenciaModal.vue?vue&type=script&lang=js"
import style0 from "./RegistrarAsistenciaModal.vue?vue&type=style&index=0&id=8171a406&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8171a406",
  null
  
)

export default component.exports